import ImageSwatch from './ImageSwatch'
import ColorSwatch from './ColorSwatch'
import { t } from '../utils/i18n'

const ComponentListBackground = ({
  onClick,
  active,
  background: { image, color }
}) => {
  const className = [
    'velorbis-customizer-component',
    'velorbis-customizer-background-component',
    active ? 'velorbis-customizer-component-active' : ''
  ].join(' ')

  return (
    <div onClick={onClick} className={className}>
      <div className="velorbis-customizer-component-name">
        {t('background')}
      </div>
      {image ? <ImageSwatch url={image} /> : <ColorSwatch hex={color} />}
    </div>
  )
}

export default ComponentListBackground
